  <div class="page-content-wrapper">
    <div class="col-sm-12">
      <HeaderSection :workflowData="workflow_data" :exporting="exporting" @export-workflow="exportWorkflow" />
      <TabsNavigation :workflowData="workflow_data" :activeTab="active_tab" :tabs="tabs" @update:activeTab="on_tab_changed" />
      <div v-if="workflow_data">
        <OverviewTab :activeTab="active_tab" :workflowData="workflow_data" />
        <ConfigurationsTab :activeTab="active_tab" :workflowData="workflow_data" :allowMultipleOnboarding="allow_multiple_onboarding" :storeApiWorkflow="store_on_api" :onBehalfOfPrepopulation="on_behalf_of_prepopulation" :allowBatchOnboarding="allow_batch_onboarding" />
        <ServicesTab :activeTab="active_tab" :workflowData="workflow_data" @open-modal="open_modal" />
        <TermsTab :activeTab="active_tab" :workflowData="workflow_data" :termsStatus="terms_status" />
        <ReasonsTab :activeTab="active_tab" :workflowData="workflow_data" />
        <RouterTab :activeTab="active_tab" :workflowData="workflow_data" :internalWorkflows="internal_workflows" :externalWorkflows="external_workflows" @open-modal="open_modal" />
        <ConfirmationTab :activeTab="active_tab" :workflowData="workflow_data" />
      </div>
      <FooterActions :workflowData="workflow_data" @decline-workflow="decline_workflow" @approve-workflow="approve_workflow" />
    </div>
  </div>
